// VG 2.0 · Phase 11B — Public API client for network applications.
//
// Bounded to the public submission endpoint. No admin calls.

const API = process.env.REACT_APP_BACKEND_URL;

function _newOperationId() {
  const rand = Math.random().toString(36).slice(2, 12);
  return `na-${Date.now()}-${rand}`;
}

export const PRIVACY_NOTICE_VERSION = "vg2_p11b_v1_draft";

/**
 * Canonical ProfessionalRole enum (mirrors Phase 9). Public labels
 * only — the values MUST match backend `services/vg2/network/models.py`.
 */
export const PROFESSIONAL_ROLES = [
  { value: "PROPERTY_ADVISOR", label: "Property Advisor" },
  { value: "REAL_ESTATE_AGENT", label: "Agente immobiliare" },
  { value: "ARCHITECT", label: "Architetto" },
  { value: "SURVEYOR", label: "Geometra" },
  { value: "ENGINEER", label: "Ingegnere" },
  { value: "NOTARY", label: "Notaio" },
  { value: "LAWYER", label: "Avvocato" },
  { value: "TAX_ADVISOR", label: "Commercialista / Consulente fiscale" },
  { value: "CONTRACTOR", label: "Impresa / Ristrutturazione" },
  { value: "ENERGY_CERTIFIER", label: "Certificatore energetico" },
  { value: "FINANCIAL_ADVISOR", label: "Consulente finanziario" },
];

export async function submitNetworkApplication(payload) {
  const body = {
    first_name: payload.first_name.trim(),
    last_name: payload.last_name.trim(),
    business_name: payload.business_name?.trim() || null,
    email: payload.email.trim(),
    phone: payload.phone.trim(),
    professional_role: payload.professional_role,
    city: payload.city.trim(),
    coverage_areas: (payload.coverage_areas || [])
      .map((s) => s.trim())
      .filter(Boolean),
    professional_description: payload.professional_description.trim(),
    motivation: payload.motivation.trim(),
    website: payload.website?.trim() || null,
    registration_body: payload.registration_body?.trim() || null,
    registration_number: payload.registration_number?.trim() || null,
    privacy_notice_version: PRIVACY_NOTICE_VERSION,
    privacy_notice_acknowledged: !!payload.privacy_notice_acknowledged,
    operation_id: payload.operation_id || _newOperationId(),
  };
  Object.keys(body).forEach((k) => {
    if (body[k] === null || body[k] === "") delete body[k];
  });
  const r = await fetch(`${API}/api/v2/public/network-applications`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!r.ok) {
    let detail = null;
    try { detail = await r.json(); } catch (e) { /* ignore */ }
    const err = new Error(detail?.detail?.message || `HTTP ${r.status}`);
    err.status = r.status;
    err.detail = detail;
    throw err;
  }
  return await r.json();
}
